import type { IANATimezones } from '@gcv/shared';

import { DateTimeHelpers } from 'util/dateTime.util';
import type { RollupCoverage } from './get-rollup-coverage';

const pluralize = (count: number, singular: string) => `${count} ${singular}${count === 1 ? '' : 's'}`;

export const formatRollupSummary = (coverage: RollupCoverage, timezone?: IANATimezones): string => {
  if (coverage.isEmpty) {
    return 'No child accounts have been assessed yet.';
  }

  const lastUpdated = coverage.lastUpdatedOn
    ? `, last updated ${DateTimeHelpers.formatISOToFriendlyDateString(coverage.lastUpdatedOn, timezone)}`
    : '';

  if (coverage.isPartial) {
    const missing = coverage.missingCount;

    return (
      `Average of ${coverage.assessedCount} of ${coverage.childCount} child accounts${lastUpdated}. ` +
      `${pluralize(missing, 'account')} ${missing === 1 ? 'has' : 'have'} not been assessed.`
    );
  }

  return `Average of the ${pluralize(coverage.assessedCount, 'assessed child account')}${lastUpdated}.`;
};
